import { render } from "./App.vue?vue&type=template&id=29c3287d"
const script = {}

import "./App.vue?vue&type=style&index=0&id=29c3287d&lang=css"
script.render = render

export default script